import ScreenshotCarousel from '../components/ScreenshotCarousel';
import { TESTFLIGHT_URL } from '../lib/platform';

const productShots = [
  { src: '/screens/1_Pick_Coach.png', alt: 'DJINN coach selection screen', label: 'Choose your coach' },
  { src: '/screens/2_Split_Preference.png', alt: 'DJINN training split preferences', label: 'Shape your split' },
  { src: '/screens/3_Plan_Generation.png', alt: 'DJINN creating a personalised training plan', label: 'Your plan, built for you' },
  { src: '/screens/4_Home.png', alt: 'DJINN home screen with today’s workout', label: 'Your training, in focus' },
  { src: '/screens/5_Workout.png', alt: 'DJINN live workout screen', label: 'Every set, accounted for' },
  { src: '/screens/6_Training_Overview.jpeg', alt: 'DJINN training overview with workout schedule', label: 'Your training at a glance' },
  { src: '/screens/7_Insights.jpeg', alt: 'DJINN training insights and progress', label: 'Progress you can see' },
  { src: '/screens/8_Chat.png', alt: 'DJINN coach conversation', label: 'A coach in your corner' },
];

function Arrow() {
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M4 12h15m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

function Phone({ src, alt, className = '' }: { src: string; alt: string; className?: string }) {
  return <div className={`phone ${className}`}><div className="phone-screen"><img src={src} alt={alt} /></div></div>;
}

export default function Home() {
  return (
    <>
      <section className="hero" aria-labelledby="hero-title">
        <div className="hero-photo" aria-hidden="true" />
        <div className="hero-shade" aria-hidden="true" />
        <div className="site-width hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">AI strength training coach</p>
            <h1 id="hero-title">Train smarter.<br />Get stronger.</h1>
            <p className="hero-lead">Training that learns as you go.</p>
            <p className="hero-detail">A training plan that fits your life, a clear way to log every session, and a coach who helps you keep moving forward.</p>
            <div className="hero-actions">
              <a className="button-primary" href={TESTFLIGHT_URL} target="_blank" rel="noopener noreferrer">Join the beta <Arrow /></a>
            </div>
          </div>
          <div className="hero-phones" aria-label="DJINN app preview">
            <Phone src="/screens/4_Home.png" alt="DJINN home screen" className="phone-front" />
            <Phone src="/screens/8_Chat.png" alt="DJINN coach chat" className="phone-back" />
          </div>
        </div>
      </section>

      <section id="product" className="story-section" aria-labelledby="story-title">
        <div className="story-image"><img src="/images/gym-shaker-djinn.jpg" alt="DJINN shaker bottle on a gym bench, with a barbell in the background" loading="lazy" /></div>
        <div className="story-content">
          <p className="eyebrow">Built around your progress</p>
          <h2 id="story-title">Your plan.<br />Always in motion.</h2>
          <p>Djinn turns your goal, schedule and training history into a plan you can actually follow. Log the work, see what comes next, and adjust with your coach when life changes.</p>
        </div>
      </section>

      <section id="screens" className="screens-section" aria-labelledby="screens-title">
        <div className="site-width">
          <div className="carousel-heading">
            <p className="eyebrow">See it in action</p>
            <h2 id="screens-title">A closer look at <span>DJINN.</span></h2>
          </div>
          <ScreenshotCarousel slides={productShots} />
        </div>
      </section>
    </>
  );
}
